/* global axios */
import ApiClient from '../ApiClient';

class GmailClient extends ApiClient {
  constructor() {
    super('gmail', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorization`, payload);
  }
}

export default new GmailClient();
